import history from '../../../util/history'

const onMonthChanged = (month, hotel_id) => {
  if (month) {
    history.push(`/monthly/accommodation_tax/date/${month}`, { hotel_id: hotel_id })
  } else {
    history.push(`/monthly/accommodation_tax`)
  }

  return true
}

export default onMonthChanged
